import Vue from 'vue';
import moment from "moment";

function initialDonationState() {
    return {
        key: null,
        updateddate: null,
        createddate: null,
        formWizardCurrentStep: 0,
        url: null,
        method: null,
        isLoading: false,
        // Step1
        isGift: false,
        packagecode: null,
        type: null, // Single/Regular selected
        campaignid: null,
        fundid: null,
        amount: null,
        dollarhandle: null,
        email: null,
        optin: true,
        // Step2
        isBehalfBusiness: false,
        bussiness: {
            name: null
        },
        title: null,
        firstname: null,
        lastname: null,
        phone: null,
        billing: {
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: '',
            suburb: null,
            country: 'Australia'
        },
        isSameAddress: true,
        gift: {
            title: null,
            firstname: null,
            lastname: null,
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: null,
            suburb: null,
            country: null
        },
        wildcard: {
            dear: null,
            message: null,
            email: null,
            scheduledate: null,
            img: null,
            pdf: null
        },
        payementType: 'wwf_purchasetokenise',
        transactionid: null,
        isProcessing: false,
        step2Data: {
            addressSelected: null,
            addressgiftSelected: null,
            showAddressSuggestions: true,
            showAddressGiftSuggestions: true,
            showFullAddress: false,
            showFullAddressGifts: false,
        },
        thankYouUrl: null,
        isImpact: false,
        emailValidation: null,
        addressInput: {
            country: 'Australia'
        }
    }
}

const state = {
    donation: initialDonationState()
}

const getters = {
    donation: state => state.donation,
    step2Data: state => state.donation.step2Data
}

const mutations = {
    updateDonation: function (state, { field, value }) {
        if (value != undefined) {
            Object.assign(state.donation, {
                [field]: value
            });
        }
    },
    updateDonationBussiness: function (state, { field, value }) {
        if (value != undefined) {
            Object.assign(state.donation.bussiness, {
                [field]: value
            });
        }
    },
    updateDonationBilling: function (state, { field, value }) {
        if (value != undefined) {
            Object.assign(state.donation.billing, {
                [field]: value
            });
        }
    },
    updateDonationGift: function (state, { field, value }) {
        if (value != undefined) {
            Object.assign(state.donation.gift, {
                [field]: value
            });
        }
    },
    updateDonationWildcard: function (state, { field, value }) {
        if (value != undefined) {
            Object.assign(state.donation.wildcard, {
                [field]: value
            });
        }
    },
    updateStep2Data: function (state, { field, value }) {
        if (value != undefined) {
            Object.assign(state.donation.step2Data, {
                [field]: value
            });
        }
    },
    resetDonation: function () {
        console.log("resetDonation mutation", state);
        const s = initialDonationState()
        Object.keys(s).forEach(key => {
            state.donation[key] = s[key]
        })
    },
    setTransactionId(state, id) {
        console.log('donate - setTransactionId - ', id);
        state.donation = { ...state.donation, transactionid: id };
    }
}

const actions = {
    saveDonation: function ({ state, getters, commit }, extra) {
        return new Promise((resolve, reject) => {

            // Define Thank you url based on donation type
            const donationType = state.donation.type;
            const donationTypeSettings = getters.product.donationsettings[donationType];
            const thankYouUrl = donationTypeSettings ? donationTypeSettings.thankYouUrl : null;
            commit('updateDonation', { field: 'thankYouUrl', value: thankYouUrl });

            // Build the payload
            const donation = {
                key: state.donation.key,
                ssoId: getters.ssoId,

                amount: state.donation.amount,
                dollarhandle: state.donation.dollarhandle,
                type: state.donation.type, // Single/Regular selected
                payementType: state.donation.payementType,

                // Supporter's details
                email: state.donation.email,
                bussiness: state.donation.isBehalfBusiness ? {
                    name: state.donation.bussiness.name
                } : null,
                title: state.donation.title,
                firstname: state.donation.firstname,
                lastname: state.donation.lastname,
                phone: state.donation.phone,

                // Flags
                optin: state.donation.optin,
                isGift: state.donation.isGift,
                bequest: state.donation.bequest,
                isSameAddress: state.donation.isSameAddress,

                // Fundraising ids
                appealid: getters.product.appealcodesetting.appealid,
                campaignid: state.donation.campaignid,
                fundid: getters.queryParams.fundid ? getters.queryParams.fundid : state.donation.fundid,
                packagecode: state.donation.packagecode,

                // Product
                producttype: getters.product.producttype,
                productname: getters.product.productname,
                productid: getters.product.id,

                certificateurl: !!getters.product.certificateurl ? getters.product.certificateurl : null,

                source: getters.product.source,
                formWizardCurrentStep: state.donation.formWizardCurrentStep,
                thankYouUrl,
                extra,

                // Impact Project
                isImpact: getters.product.extrasetting.isImpact,

                // Email Validation
                emailValidation: state.donation.emailValidation
            };

            // Set the addresses
            donation.billing = {
                unitnumber: state.donation.billing.unitnumber,
                streetno: state.donation.billing.streetno,
                streetname: state.donation.billing.streetname,
                postcode: state.donation.billing.postcode,
                state: state.donation.billing.state,
                suburb: state.donation.billing.suburb,
                country: state.donation.billing.country,
                isVerified: state.donation.billing.isVerified
            };

            if (donation.isGift) {
                donation.gift = {
                    title: state.donation.gift.title,
                    firstname: state.donation.gift.firstname,
                    lastname: state.donation.gift.lastname,
                };

                if (!donation.isSameAddress) {
                    donation.gift = {
                        ...donation.gift,
                        unitnumber: state.donation.gift.unitnumber,
                        streetno: state.donation.gift.streetno,
                        streetname: state.donation.gift.streetname,
                        postcode: state.donation.gift.postcode,
                        state: state.donation.gift.state,
                        suburb: state.donation.gift.suburb,
                        country: state.donation.gift.country
                    };
                }
            }

            // Set the wildcard
            if (getters.product.producttype === "wildcard" && state.donation.wildcard) {
                donation.wildcard = {
                    dear: state.donation.wildcard.dear,
                    message: state.donation.wildcard.message,
                    email: state.donation.wildcard.email,
                    scheduledate: state.donation.wildcard.scheduledate ? moment(state.donation.wildcard.scheduledate).format('YYYY-MM-DD') : null,
                    img: state.donation.wildcard.img,
                    pdf: state.donation.wildcard.pdf
                }
            }

            console.log('donation', donation);

            Vue.http.post(`${wwfconfigs.WEB_API}/donation`, donation).then(response => {
                console.log('Save doantion - Success');

                // If the key was not define, set the key we just received
                if (!donation.key) {
                    commit("updateDonation", { field: 'key', value: response.body.key });
                }

                resolve();
            }, error => {
                console.error('Save doantion - Error - ', error)
                reject(error);
            });

        });
    },
    saveDonationStep1: function ({ dispatch, state, commit, rootState, getters }) {
        return new Promise((resolve, reject) => {

            const donationType = state.donation.type;
            const donationTypeSettings = getters.product.donationsettings[donationType];
            const thankYouUrl = donationTypeSettings ? donationTypeSettings.thankYouUrl : null;

            commit('updateDonation', { field: 'thankYouUrl', value: thankYouUrl });

            // queryParams.fundid is the fundid set by query params. Always use this one if available
            const donation = {
                key: state.donation.key,
                isGift: state.donation.isGift,
                packagecode: state.donation.packagecode,
                type: state.donation.type, // Single/Regular selected
                amount: state.donation.amount,
                dollarhandle: state.donation.dollarhandle,
                email: state.donation.email,
                optin: state.donation.optin,
                appealid: rootState.product.product.appealcodesetting.appealid,
                campaignid: state.donation.campaignid,
                fundid: rootState.product.queryParams.fundid ? rootState.product.queryParams.fundid : state.donation.fundid,
                producttype: rootState.product.product.producttype,
                productname: rootState.product.product.productname,
                productid: rootState.product.product.id,
                certificateurl: (rootState.product.product.certificateurl) ? rootState.product.product.certificateurl : null,
                source: rootState.product.product.source,
                formWizardCurrentStep: state.donation.formWizardCurrentStep,
                ssoId: getters.ssoId,
                thankYouUrl,
                emailValidation: state.donation.emailValidation
            };

            console.log('Save donation Step 1', donation);

            // if donation already exist
            if (state.donation.key) {
                console.log('Save donation with key', state.donation.key);
                Vue.http.post(`${wwfconfigs.WEB_API}/donation`, donation).then(response => {
                    console.log('saveDonation Step 1: Update Success');
                    resolve();
                }, error => {
                    console.log('Error has occured during saving step1 update process', error)
                    reject(error);
                });
            } else {
                console.log('Save donation without key');
                Vue.http.post(`${wwfconfigs.WEB_API}/donation`, donation).then(response => {
                    console.log('saveDonation Step 1: Creation Success');
                    commit("updateDonation", { field: 'key', value: response.body.key });
                    resolve();
                }, error => {
                    console.log('Error has occured during saving step1 create process', error)
                    reject(error);
                });
            }
        });
    },
    saveDonationStep2: function ({ dispatch, state, commit }) {
        return new Promise((resolve, reject) => {
            console.log('saveDonationStep2 State donation', state.donation);
            console.log('saveDonationStep2 State product', state.product);

            const donation = {
                key: state.donation.key,
                isGift: state.donation.isGift,
                email: state.donation.email,
                optin: state.donation.optin,
                type: state.donation.type, // Single/Regular selected
                bussiness: state.donation.isBehalfBusiness ? {
                    name: state.donation.bussiness.name
                } : null,
                title: state.donation.title,
                firstname: state.donation.firstname,
                lastname: state.donation.lastname,
                phone: state.donation.phone,
                billing: {
                    unitnumber: state.donation.billing.unitnumber,
                    streetno: state.donation.billing.streetno,
                    streetname: state.donation.billing.streetname,
                    postcode: state.donation.billing.postcode,
                    state: state.donation.billing.state,
                    suburb: state.donation.billing.suburb,
                    country: state.donation.billing.country,
                    isVerified: state.donation.billing.isVerified
                },
                isSameAddress: state.donation.isSameAddress,
                gift: state.donation.isGift ? {
                    title: state.donation.gift.title,
                    firstname: state.donation.gift.firstname,
                    lastname: state.donation.gift.lastname,
                    unitnumber: !state.donation.isSameAddress ? state.donation.gift.unitnumber : null,
                    streetno: !state.donation.isSameAddress ? state.donation.gift.streetno : null,
                    streetname: !state.donation.isSameAddress ? state.donation.gift.streetname : null,
                    postcode: !state.donation.isSameAddress ? state.donation.gift.postcode : null,
                    state: !state.donation.isSameAddress ? state.donation.gift.state : null,
                    suburb: !state.donation.isSameAddress ? state.donation.gift.suburb : null,
                    country: !state.donation.isSameAddress ? state.donation.gift.country : null
                } : null,
                wildcard: state.donation.wildcard
                    ? {
                        dear: state.donation.wildcard.dear,
                        message: state.donation.wildcard.message,
                        email: state.donation.wildcard.email,
                        scheduledate: state.donation.wildcard.scheduledate ? moment(state.donation.wildcard.scheduledate).format('YYYY-MM-DD') : null,
                        img: state.donation.wildcard.img,
                        pdf: state.donation.wildcard.pdf
                    }
                    : null,
                payementType: state.donation.payementType,
                formWizardCurrentStep: state.donation.formWizardCurrentStep,
                bequest: state.donation.bequest
            };

            console.log('saveDonationStep2 Donation', donation);
            Vue.http.post(`${wwfconfigs.WEB_API}/donation`, donation).then(response => {
                console.log('saveDonation Step 2 set success', response);
                resolve();
            }, error => {
                console.log('Error has occured during saving step2 set process', error);
                reject(error);
            });
        });
    },
    paymentCreditCard: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isLoading = true;
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.WEB_API + '/payment/credit-card/checkout', {
                token: data.token,
                cardHolderName: data.cardHolderName,
                uid: state.donation.key
            }).then(response => {
                console.log("payment", response);
                state.donation.isLoading = false;
                resolve(response);
            }, error => {
                console.error("payment", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        })
    },
    paymentDirectDebit: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isLoading = true;
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.WEB_API + '/payment/direct-debit/checkout', {
                accno: data.accno,
                accrouting: data.accrouting,
                acctitle: data.acctitle,
                uid: state.donation.key
            }).then(response => {
                console.log("payment", response);
                state.donation.isLoading = false;
                resolve(response);
            }, error => {
                console.error("payment", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        })
    },
    checkoutPaypal: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isLoading = true;
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.WEB_API + '/payment/paypal/checkout', {
                uid: state.donation.key
            }).then(response => {
                console.log("checkoutPaypal", response);
                state.donation.isLoading = false;
                resolve(response.body);
            }, error => {
                console.error("checkoutPaypal", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        })
    },
    paymentPaypal: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isProcessing = true
        console.log('paymentPaypal', data);
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.WEB_API + '/payment/paypal/purchase', {
                paymentid: data.paymentid,
                payerid: data.payerid
            }).then(response => {
                console.log("paymentPaypal", response);
                state.donation.isProcessing = false
                resolve(response.body);
            }, error => {
                console.error("paymentPaypal", error);
                //Todo reset id firebase
                state.donation.isProcessing = false
                reject(error);
            });
        })
    },
    retryDonation: async function ({ commit, dispatch }) {
        // Set the value to empty because the previous donation is failed
        commit("updateDonation", { field: "key", value: '' });
        await dispatch("saveDonationStep1");
        return await dispatch("saveDonationStep2");
    },
    resetDonation: function ({ commit }) {
        commit("resetDonation");
    },
    getCustomCheckoutFeatureSwitch({ commit }, productId) {
        return new Promise((resolve, reject) => {
            Vue.http.get(`${wwfconfigs.WEB_API}/setting?settingId=bambora-checkout`,).then(response => {
                const setting = response.body;
                const productSetting = setting.products[productId];
                const active = productSetting !== undefined && productSetting !== null ? productSetting : setting.default;
                resolve(active);
            }, error => {
                console.error("getCustomCheckoutFeatureSwitch", error);
                reject(error);
            });
        });
    },

    // OLD BAMBORA CHECKOUT
    checkout: function ({ dispatch, state, commit, rootState }) {
        console.log('checkout', state)
        commit("updateDonation", { field: 'method', value: '' });
        commit("updateDonation", { field: 'url', value: '' });
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.CHECKOUT, {
                // The method doesnt like the amount with. 
                amount: state.donation.amount.replace(',', ''),
                //amount: state.donation.amount
                paymentType: state.donation.payementType,
                email: state.donation.email,
                custRef: state.donation.key,
                productid: rootState.product.product.id,// ok
                productname: rootState.product.product.productname, // ok
                producttype: rootState.product.product.producttype, // Ok
                campaignid: rootState.product.product.appealcodesetting.campaignid, // ok
                fundid: rootState.product.product.appealcodesetting.fundid, //ok 
                appealid: rootState.product.product.appealcodesetting.appealid,//ok
                type: state.donation.type,
                source: rootState.product.product.source
            }).then(response => {
                console.log("checkout", response)
                commit("updateDonation", { field: 'method', value: response.body.method });
                commit("updateDonation", { field: 'url', value: response.body.url });
                resolve(response)
            }, error => {
                console.error("checkout", error)
                reject(error)
            });
        })
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/donate.js